import { toast } from "react-hot-toast"

export const taasBasedTableData = [{ ss: 1, dc: 2, db: 3, requirement: "Estimated No. of FTEs" }]

export const TAAS_TABLE_SECTION_KEYS = {
    TAAS_BASED: "TaaS Based",
    PROJECT_BASED: "Project Based",
    STAFF_AUGMENTATION: "Staff Augmentation",
    BOT: "BOT"
}

export const taasInnerTableKeys = {
    REQUIREMENT: "requirement",
    SURVEY_SCRIPTING: "surveyScripting",
    DATA_PROCESSING: "dataProcessing",
    DATA_VISUALIZATION: "dataVisualization"
}

export let STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS = {
    ESTIMATED_NUMBER_OF_FTEs: "Estimated no. of FTEs",
    SPECIFY_TIME_IN_MONTHS: "(Specify Time in Months…)"
}

export let PROJECT_BASED_TABLE_KEYS = {
    ESTIMATED_NUMBER_OF_HOURS_PER_MONTH: "Estimated no. of Hours per month",
    ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH: "Estimated no. of Projects per month"
}

export const TaasTableSectionData = {
    [TAAS_TABLE_SECTION_KEYS.TAAS_BASED]: {
        headingText: "Similar to FTE model by providing full time resources for research functions and contracts renewed annually.",
        tableData: [{ [taasInnerTableKeys.REQUIREMENT]: "Estimated No. of FTEs" }],
        copyId: "taasBased"
    },
    [TAAS_TABLE_SECTION_KEYS.PROJECT_BASED]: {
        headingText: "Individual project-based engagement",
        tableData: [{ [taasInnerTableKeys.REQUIREMENT]: PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_HOURS_PER_MONTH }, { [taasInnerTableKeys.REQUIREMENT]: "OR" },
        { [taasInnerTableKeys.REQUIREMENT]: PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH }],
        copyId: "projectBased"
    },
    [TAAS_TABLE_SECTION_KEYS.STAFF_AUGMENTATION]: {
        headingText: "Provide staff for specific skillset to fill positions for short term engagements",
        tableData: [{ [taasInnerTableKeys.REQUIREMENT]: STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.ESTIMATED_NUMBER_OF_FTEs }, { [taasInnerTableKeys.REQUIREMENT]: STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.SPECIFY_TIME_IN_MONTHS }],
        copyId: "staffAugmentation"
    },
    [TAAS_TABLE_SECTION_KEYS.BOT]: {
        headingText: "Build-Operate-Transfer model of executing very large engagements and larger teams",
        tableData: [{ [taasInnerTableKeys.REQUIREMENT]: STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.ESTIMATED_NUMBER_OF_FTEs }, { [taasInnerTableKeys.REQUIREMENT]: STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.SPECIFY_TIME_IN_MONTHS }],
        copyId: "bot"
    }
}

export const TaasTableSectionViewData = {
    ...TaasTableSectionData,
    [TAAS_TABLE_SECTION_KEYS.PROJECT_BASED]: {
        headingText: "Individual project-based engagement",
        tableData: [{ [taasInnerTableKeys.REQUIREMENT]: PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_HOURS_PER_MONTH },
        { [taasInnerTableKeys.REQUIREMENT]: PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH }],
        copyId: "projectBased"
    }
}

export function copyTable(id) {
    const { ClipboardItem } = window;
    let urlField = document.querySelector(`#${id} table`);
    let clone = urlField.cloneNode(true)
    clone.style.background = "#fff"
    clone.style.borderColor = "#eee"

    clone.querySelectorAll('thead > tr > th').forEach(item => item.style = "background: #bd1822; color: #fff;")

    const blob = new Blob([clone.outerHTML], { type: "text/html" })
    navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
    if (!blob) {
        return toast.error("Unable to Copy!")
    }
    toast.success("Successfully Copied!")
}